/* global window, document, navigator */
const banner = document.getElementById('app-store-banner')
const dismissalKey = 'fantasyshl-app-banner-dismissed-until'
const isNative = window.Capacitor?.isNativePlatform?.() || /; wv\)/i.test(navigator.userAgent)
const isStandalone = window.matchMedia('(display-mode: standalone)').matches || window.matchMedia('(display-mode: fullscreen)').matches

if (banner && /Android/i.test(navigator.userAgent) && !isNative && !isStandalone) {
  let dismissedUntil = 0
  try {
    dismissedUntil = Number(window.localStorage.getItem(dismissalKey)) || 0
  } catch (_) {
    // The banner still works when browser storage is unavailable.
  }

  if (dismissedUntil <= Date.now()) banner.hidden = false

  const dismiss = () => {
    banner.hidden = true
    try {
      window.localStorage.setItem(dismissalKey, String(Date.now() + 7 * 24 * 60 * 60 * 1000))
    } catch (_) {
      // Dismissal remains effective for this page when storage is unavailable.
    }
  }
  banner.querySelector('button').addEventListener('click', dismiss)

  let installPrompt
  window.addEventListener('beforeinstallprompt', event => {
    // Only replace the store link when Chrome offers this native Play app.
    if (!event.platforms?.includes('play')) return
    event.preventDefault()
    installPrompt = event
  })
  banner.querySelectorAll('a').forEach(link => {
    link.addEventListener('click', async event => {
      if (!installPrompt) return
      event.preventDefault()
      const prompt = installPrompt
      installPrompt = null
      try {
        await prompt.prompt()
        const choice = await prompt.userChoice
        if (choice.outcome === 'accepted') banner.hidden = true
      } catch (_) {
        window.location.assign(link.href)
      }
    })
  })
  window.addEventListener('appinstalled', () => { banner.hidden = true })
}
